import React, { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  getDeliveriesStageCurrent,
  selectDeliveriesStagePlanData,
  selectDeliveriesStagePlanError,
  selectDeliveriesStagePlanIsLoading
} from '../selectors'
import { getDeliveriesStagePlanData } from '../../../../store/deliveries/action-creators'
import { StagePlanDeliveriesSync as StagePlanDeliveries } from '../../../../components/v2/stage-plan-deliveries'
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'

interface DeliveriesStagePlanProps {
  className?: string
  id: string | number
  hideHeader?: boolean
}

export const DeliveryStagePlan: React.FC<DeliveriesStagePlanProps> = memo((props: DeliveriesStagePlanProps) => {
  const { className, id, hideHeader } = props
  const dispatch = useAppDispatch()
  const stagePlanIsLoading = useSelector(selectDeliveriesStagePlanIsLoading)
  const stagePlanError = useSelector(selectDeliveriesStagePlanError)
  const stagePlanFiles = useSelector(selectDeliveriesStagePlanData)
  const stage = useSelector(getDeliveriesStageCurrent)

  useEffect(() => {
    let mounted = true
    if (stage !== undefined && id !== 'new') {
      if (mounted) {
        dispatch(getDeliveriesStagePlanData(id))
      }
    }
    return () => {
      mounted = false
    }
  }, [stage, id, dispatch])

  return (
    <StagePlanDeliveries
      isLoading={stagePlanIsLoading}
      items={stagePlanFiles}
      error={stagePlanError}
      className={className}
      hideHeader={hideHeader}
    />
  )
})
